<script>
  import Modal from '@components/general/modal.svelte'
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import { useForm } from '@inertiajs/svelte'
  import { Save, CirclePlus, Trash2, PoundSterling } from 'lucide-svelte'

  let { offer, programme, open = $bindable(false), onClose, onSuccess } = $props()

  let title = $derived(offer ? `Edit ${offer.name}` : "Create a new offer")
  let isUpdate = $derived(offer?.id)

  const form = $derived(useForm({
    name: offer?.name || '',
    amount: offer?.amount || '',
    opens_on: offer?.opens_on || '',
    closes_on: offer?.closes_on || '',
    active: offer?.active ?? true,
  }))

  const deleteForm = useForm()

  function handleClose() {
    onClose?.()
    $form.reset()
    open = false
  }

  function handleSuccess() {
    onSuccess?.()
    open = false
    $form.reset()
  }

  function handleCreate() {
    $form.transform((data) => ({ offer: data }))
    $form.post(`/admin/programmes/${programme.id}/offers`, { onSuccess: handleSuccess })
  }

  function handleUpdate() {
    $form.transform((data) => ({ offer: data }))
    $form.put(`/admin/programmes/${programme.id}/offers/${offer.id}`, { onSuccess: handleSuccess })
  }

  function handleSubmit(e) {
    e.preventDefault()
    isUpdate ? handleUpdate() : handleCreate()
  }

  function handleDelete() {
    if (!window.confirm(`Are you sure you want to delete ${offer.name}?`)) return
    $deleteForm.delete(`/admin/programmes/${programme.id}/offers/${offer.id}`, { onSuccess: handleClose })
  }
</script>

<Modal bind:open {title} onClose={handleClose}>

  <Form.Element {form} id="offer-form" onsubmit={handleSubmit}>

    <Form.Items>

      <!-- Programme name (disabled) -->
      <Form.Item name="programme" value={programme.name} label="Programme" cols={12} disabled readonly />

      <!-- Name -->
      <Form.Item name="name" bind:value={$form.name} label="Name" hint="e.g. Early Bird, Standard, Half-Year" cols={12} required />

      <!-- Offer opens -->
      <Form.Item name="opens_on" bind:value={$form.opens_on} label="Opens on" hint="When this offer becomes available" type="date" cols={6} />

      <!-- Offer closes -->
      <Form.Item name="closes_on" bind:value={$form.closes_on} label="Closes on" hint="When this offer stops being available" type="date" cols={6} />

      <!-- Price -->
      <Form.Item name="amount" bind:value={$form.amount} label="Price (GBP excluding VAT)" hint="e.g. 150.00" cols={12} type="number" step="0.01" min="0" required>
        {#snippet prefix()}
          <PoundSterling size={12} class="text-gray-400" />
        {/snippet}
      </Form.Item>

      <!-- Active -->
      <Form.Item name="active" bind:value={$form.active} label="Status" cols={12} options={[
        { value: true, label: "Active" },
        { value: false, label: "Inactive" },
      ]} />

    </Form.Items>

  </Form.Element>

  {#snippet footer()}
    {#if isUpdate}
      <Button variant="warning" text="Delete" Icon={Trash2} onclick={handleDelete} loading={$deleteForm.processing} />
    {/if}
    <Button type="submit" form="offer-form" text={isUpdate ? "Update offer" : "Create offer"} variant="submit" Icon={isUpdate ? Save : CirclePlus} loading={$form.processing} />
  {/snippet}

</Modal>
